import React from 'react';
import PropTypes from 'prop-types';

function Handshake({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M17.26 12.585l2.034 2.037a1.5 1.5 0 002.122-2.121L16.38 7.462c-.915-.914-1.926-1.002-3.006.078l-.314.311a1.5 1.5 0 01-2.12-2.121L12 4.67C13.225 3.445 13.921 3 14.952 3h1.628l6.67 6.666-2.336 2.336"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M17.255 12.585l2.567 2.565a1.5 1.5 0 01-2.122 2.123l-2.34-2.341"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M15.36 14.932l1.81 1.81a1.5 1.5 0 01-2.12 2.12l-1.06-1.06"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M3.169 12.003L.75 9.583l6.008-6.009s.8.931 1.471.931c.816 0 1.015-.265 1.5-.75.797-.797 1.995-.774 3 .23l-9.56 8.018zm10.937 5.915l.521.522a1.5 1.5 0 01-2.12 2.121l-.52-.522 2.119-2.121z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M5.85 13.562a1.502 1.502 0 00-.463-2.485 1.5 1.5 0 00-1.657.364L2.67 12.5a1.5 1.5 0 002.121 2.12l1.059-1.06z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M7.972 15.682A1.5 1.5 0 105.85 13.56L4.26 15.15a1.5 1.5 0 002.121 2.12l1.59-1.588zm2.12 2.12a1.5 1.5 0 00-2.12-2.12l-1.06 1.06a1.5 1.5 0 002.12 2.12l1.06-1.06z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M12.097 20.038a1.499 1.499 0 00-1.061-2.56 1.5 1.5 0 00-1.061.44l-.522.522a1.5 1.5 0 002.12 2.121l.524-.523z"
      />
    </svg>
  );
}

Handshake.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Handshake;
